export default "__VITE_ASSET__BwQdbT0h__"